import * as Yup from "yup";

const stringLengths = {
  min: 1,
  utmMin: 3,
  titleMax: 128,
  headingMax: 256,
  bodyMax: 2048,
  callToActionMax: 128,
  destinationUrlMax: 2048,
};

export const messageInfo = Yup.object().shape({
  title: Yup.string()
    .trim()
    .required("Title is required")
    .min(stringLengths.min, `Title must have at least ${stringLengths.min} characters`)
    .max(stringLengths.titleMax, `Title cannot exceed ${stringLengths.titleMax} characters`),
  utmCampaign: Yup.string()
    .trim()
    .required("Campaign Name is required")
    .min(stringLengths.utmMin, `Campaign Name must have at least ${stringLengths.utmMin} characters`)
    .max(stringLengths.titleMax, `Campaign Name cannot exceed ${stringLengths.titleMax} characters`),
});

export const messageContent = Yup.object().shape({
  headline: Yup.string()
    .trim()
    .required("Heading is required")
    .min(stringLengths.min, `Heading must have at least ${stringLengths.min} characters`)
    .max(stringLengths.headingMax, `Heading cannot exceed ${stringLengths.headingMax} characters`),
  imageUrl: Yup.string().required("Image Cap is required"),
  body: Yup.string()
    .required("Body is required")
    .min(stringLengths.min, `Body must have at least ${stringLengths.min} characters`)
    .max(stringLengths.bodyMax, `Body cannot exceed ${stringLengths.bodyMax} characters`),
  callToAction: Yup.string()
    .required("Call to Action is required")
    .min(stringLengths.min, `Call to Action must have at least ${stringLengths.min} characters`)
    .max(stringLengths.callToActionMax, `Call to Action cannot exceed ${stringLengths.callToActionMax} characters`),
  destinationUrl: Yup.string()
    .required("Destination URL is required")
    .url("Destination must be valid URL")
    .min(stringLengths.min, `Destination URL must have at least ${stringLengths.min} characters`)
    .max(
      stringLengths.destinationUrlMax,
      `Destination URL cannot exceed ${stringLengths.destinationUrlMax} characters`,
    ),
});
